import { useCallback } from 'react';

import { useRovoAgentCreateAnalytics } from '@atlaskit/rovo-agent-analytics/create';

import { fg } from '@confluence/feature-gating';
import { useSmartCreationModalActions } from '@confluence/smart-creation-modal-store/entry-points/smartCreationModalStore.tsx';

const INLINE_CREATE_AGENT_ACTION_SUBJECT_ID = 'inlineCreateAgentItem';
const CONNIE_CREATE_SOURCE = 'connie-create';

type UseInlineCreateAgentItemClickHandlerArgs = {
	onClick: (actionSubjectId: string) => void;
	source: string;
};

export const useInlineCreateAgentItemClickHandler = ({
	onClick,
	source,
}: UseInlineCreateAgentItemClickHandlerArgs): (() => void) => {
	const { openModal } = useSmartCreationModalActions();
	const [, { trackCreateSessionStart }] = useRovoAgentCreateAnalytics({
		touchPoint: CONNIE_CREATE_SOURCE,
	});

	return useCallback(() => {
		onClick(INLINE_CREATE_AGENT_ACTION_SUBJECT_ID);
		if (fg('sltns-1529-draft-agent-non-consequential')) {
			trackCreateSessionStart();
		}
		openModal({
			entryPoint: source,
			initialOutcomeType: 'agent',
			lockInitialOutcomeType: true,
		});
	}, [onClick, openModal, source, trackCreateSessionStart]);
};
